import { CORS } from "./cors";
import { Game } from "./game";
import { AndrewsMcMeel } from "./andrewsmcmeel";

export class Default {
  static load(cb: Function) {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    Game.puzzle.year = year;
    Game.puzzle.month = month;
    Game.puzzle.day = day;

    const month_name = Game.months[month - 1].toLowerCase();
    console.log(month_name);

    let month_str = month.toString();
    if (month_str.length < 2) {
      month_str = "0" + month_str;
    }
    let day_str = day.toString();
    if (day_str.length < 2) {
      day_str = "0" + day_str;
    }
    const date_id = "" + year + month_str + day_str;

    Game.puzzle.id = "lat" + date_id;
    Game.puzzle.date_string = date_id;

    const url = `https://gamedata.services.amuniversal.com/c/uucom/l/g/g/fcx/d/${year}-${month_str}-${day_str}/data`;

    const t0 = performance.now();

    CORS.load(url, function(data: string) {
      console.log("data load");
      try {
        const jsonData = JSON.parse(data);
        AndrewsMcMeel.parse(jsonData);
        cb();
      } catch (e) {
        console.error("Error parsing puzzle data:", e);
      }
      console.log("load: " + (performance.now() - t0) + " ms");
    });
  }
}